import { themedStyled } from 'common/styles/styletron.theme';
import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import AirlineTable from './airline-table';

export default function TourFlightItem(props: { parentIdx: number }) {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`approvalable.tourFlights[${props.parentIdx}].name`}
            label={t('common:schedule_name')}
            placeholder={t('common:schedule_name')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`approvalable.tourFlights[${props.parentIdx}].note`}
            label={t('common:note')}
            placeholder={t('common:note')}
          />
        </HalfContainer>
      </SectionContainer>
      <AirlineTable parentIdx={props.parentIdx} />
    </FullContainer>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
